var _circle, _circle2, _circle3, _circle4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg3DotsLoader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#1F1E30FF",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 12,
    r: 0
  }, /*#__PURE__*/React.createElement("animate", {
    begin: "0;spinner_z0Or.end",
    attributeName: "r",
    calcMode: "spline",
    dur: "0.5s",
    keySplines: ".36,.6,.31,1",
    values: "0;3",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("animate", {
    begin: "spinner_OLMs.end",
    attributeName: "cx",
    calcMode: "spline",
    dur: "0.5s",
    keySplines: ".36,.6,.31,1",
    values: "4;12",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("animate", {
    begin: "spinner_UHR2.end",
    attributeName: "cx",
    calcMode: "spline",
    dur: "0.5s",
    keySplines: ".36,.6,.31,1",
    values: "12;20",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("animate", {
    id: "spinner_lo66",
    begin: "spinner_Aguh.end",
    attributeName: "r",
    calcMode: "spline",
    dur: "0.5s",
    keySplines: ".36,.6,.31,1",
    values: "3;0",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("animate", {
    id: "spinner_z0Or",
    begin: "spinner_lo66.end",
    attributeName: "cx",
    dur: "0.001s",
    values: "20;4",
    fill: "freeze"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 12,
    r: 3
  }, /*#__PURE__*/React.createElement("animate", {
    begin: "0;spinner_z0Or.end",
    attributeName: "cx",
    calcMode: "spline",
    dur: "0.5s",
    keySplines: ".36,.6,.31,1",
    values: "4;12",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("animate", {
    begin: "spinner_OLMs.end",
    attributeName: "cx",
    calcMode: "spline",
    dur: "0.5s",
    keySplines: ".36,.6,.31,1",
    values: "12;20",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("animate", {
    id: "spinner_JsnR",
    begin: "spinner_UHR2.end",
    attributeName: "r",
    calcMode: "spline",
    dur: "0.5s",
    keySplines: ".36,.6,.31,1",
    values: "3;0",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("animate", {
    id: "spinner_Aguh",
    begin: "spinner_JsnR.end",
    attributeName: "cx",
    dur: "0.001s",
    values: "20;4",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("animate", {
    begin: "spinner_Aguh.end",
    attributeName: "r",
    calcMode: "spline",
    dur: "0.5s",
    keySplines: ".36,.6,.31,1",
    values: "0;3",
    fill: "freeze"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 3
  }, /*#__PURE__*/React.createElement("animate", {
    begin: "0;spinner_z0Or.end",
    attributeName: "cx",
    calcMode: "spline",
    dur: "0.5s",
    keySplines: ".36,.6,.31,1",
    values: "12;20",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("animate", {
    id: "spinner_hSjk",
    begin: "spinner_OLMs.end",
    attributeName: "r",
    calcMode: "spline",
    dur: "0.5s",
    keySplines: ".36,.6,.31,1",
    values: "3;0",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("animate", {
    id: "spinner_UHR2",
    begin: "spinner_hSjk.end",
    attributeName: "cx",
    dur: "0.001s",
    values: "20;4",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("animate", {
    begin: "spinner_UHR2.end",
    attributeName: "r",
    calcMode: "spline",
    dur: "0.5s",
    keySplines: ".36,.6,.31,1",
    values: "0;3",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("animate", {
    begin: "spinner_Aguh.end",
    attributeName: "cx",
    calcMode: "spline",
    dur: "0.5s",
    keySplines: ".36,.6,.31,1",
    values: "4;12",
    fill: "freeze"
  }))), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 12,
    r: 3
  }, /*#__PURE__*/React.createElement("animate", {
    id: "spinner_4v5M",
    begin: "0;spinner_z0Or.end",
    attributeName: "r",
    calcMode: "spline",
    dur: "0.5s",
    keySplines: ".36,.6,.31,1",
    values: "3;0",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("animate", {
    id: "spinner_OLMs",
    begin: "spinner_4v5M.end",
    attributeName: "cx",
    dur: "0.001s",
    values: "20;4",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("animate", {
    begin: "spinner_OLMs.end",
    attributeName: "r",
    calcMode: "spline",
    dur: "0.5s",
    keySplines: ".36,.6,.31,1",
    values: "0;3",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("animate", {
    begin: "spinner_UHR2.end",
    attributeName: "cx",
    calcMode: "spline",
    dur: "0.5s",
    keySplines: ".36,.6,.31,1",
    values: "4;12",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("animate", {
    begin: "spinner_Aguh.end",
    attributeName: "cx",
    calcMode: "spline",
    dur: "0.5s",
    keySplines: ".36,.6,.31,1",
    values: "12;20",
    fill: "freeze"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3DotsLoader);
export default __webpack_public_path__ + "static/media/3-dots-loader.5afb4a75bd2b638d899d55018025cd94.svg";
export { ForwardRef as ReactComponent };